export class ShowItemQuantityService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async handle(params) {
    return await this.httpClient.get('/itens/SaldoItem', { params })
  }
}
